var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V41.0162H24.0809C26.194 42.8736 28.9655 44 32 44C38.6274 44 44 38.6274 44 32C44 29.5465 43.2637 27.265 42 25.3644V10.9408L31.82 13.649L21.2672 6.55369L11.042 8.39298L0 0ZM40 25.999V26.1397H40.1038C41.1128 27.5326 41.7715 29.1958 41.9506 31H40V33H41.9506C41.4816 37.7244 37.7244 41.4816 33 41.9506V40H31V41.9506C26.2756 41.4816 22.5184 37.7244 22.0494 33H24V31H22.0494C22.5184 26.2756 26.2756 22.5184 31 22.0494V24H33V22.0494C35.859 22.3332 38.3638 23.8212 40 25.999ZM40 23.0556V13.542L31.4578 15.8161L20.823 8.66498L10.5316 10.5173L2 4.03298V14.8492L10.262 21.877L21.2157 19.8895L24.7212 22.4589C26.7401 20.9163 29.263 20 32 20C35.0734 20 37.877 21.1554 40 23.0556ZM2 17.4748V39.016L22.2638 39.0162C20.8393 37.043 20 34.6195 20 32C20 28.8379 21.2231 25.9614 23.2219 23.8179L20.783 22L9.68768 24.0134L2 17.4748ZM36.8995 27L33.7175 33.7175L27 36.8995L30.182 30.182L36.8995 27Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioExplorer);
export default __webpack_public_path__ + "static/media/portfolio-explorer.985f5aa5e6cbcf46ad1cbe4962a5358e.svg";
export { ForwardRef as ReactComponent };